import React from 'react';
import { FileTextIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const highlights = ['6 tomos organizados por etapas', 'Ruta de hábitos de 15 días', '50 recetas sencillas'];
export function SystemIntro() {
  return <section className="w-full bg-white pb-12 pt-16 sm:pb-16 sm:pt-24" aria-labelledby="sistema-title" data-id="element-216" data-mp="23a6m61mnqz2u">
      <div className="mx-auto max-w-4xl px-6 text-center" data-id="element-217" data-mp="287glqa3rgr4e">
        <Reveal data-id="element-218" data-mp="1bi7isu76su06">
          <p className="mx-auto inline-flex max-w-full items-start gap-2 rounded-2xl bg-mint-50 px-3.5 py-2 text-left text-sm font-medium text-mint-700 ring-1 ring-inset ring-mint-200 sm:items-center sm:rounded-full" data-id="element-219" data-mp="1bir4mlzyk2jh">
            <FileTextIcon className="mt-0.5 h-4 w-4 shrink-0 sm:mt-0" aria-hidden="true" data-id="element-220" data-mp="1kgt06m0xa2zd" />
            <span data-id="element-221" data-mp="1pi9xk7k777b7">Material educativo en formato PDF</span>
          </p>
          <h2 id="sistema-title" className="mt-6 font-display text-3xl leading-[1.1] text-ink sm:text-5xl" data-id="element-222" data-mp="2vy2ih58beoz3">
            Megapack Salud Plena
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-ink-soft" data-id="element-223" data-mp="30yqhad2sca3v">
            Una guía ordenada sobre alimentación, hábitos y bienestar digestivo.
            Todo el material está estructurado para que sepas por dónde empezar y
            cómo avanzar, sin tener que reunir información de distintas fuentes.
          </p>
          <ul className="mx-auto mt-8 flex max-w-2xl flex-wrap justify-center gap-x-8 gap-y-3" data-id="element-224" data-mp="rjnru5ngr4bj">
            {highlights.map(item => <li key={item} className="text-sm font-medium text-mint-700" data-id="element-225" data-mp="mkkyhiguimje">
                {item}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}